/* eslint-disable prettier/prettier */
import styled from '@emotion/styled'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { theme } from 'styles/theme/hav-theme'

export const BoxColumn = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  div:last-of-type hr {
    margin-bottom: 0;
  }
  flex-grow: 1;
  max-height: 500px;

  @media (max-width: ${theme.breakpoints.md}px) {
    max-height: 600px;
  }
`
export const InfoOutlineIconStyled = styled(InfoOutlinedIcon)`
  color: ${theme.colors.primary.main};
  width: ${theme.icon.size.small};
  height: ${theme.icon.size.small};
`

export const ColorTitleStyled = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${theme.spacing.xs};
  align-items: center;
`
export const LabelStyled = styled.div`
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.xs};
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: ${theme.spacing.xs};
  align-items: center;
  max-width: 66px;

  margin-bottom: ${theme.spacing.xs};
`
export const ToolTipBox = styled.div`
  font-size: ${theme.typography.sizes['2xs']};
  padding: ${theme.spacing.md};

  #title {
    display: block;
    font-weight: ${theme.typography.weight.xsm};
    color: ${theme.colors.neutral.black};
  }
`
export const ColorBor = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 80px;

  #title {
    font-size: ${theme.typography.sizes.xs};
    color: ${theme.colors.neutral.high};
  }

  #strategic {
    font-weight: ${theme.typography.weight.lg};
    font-size: ${theme.typography.sizes['3xs']};
    color: ${theme.colors.alert.success.dark};
  }
`

export const ColorDescription = styled.span`
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes['3xs']};
  color: ${theme.colors.neutral.high};

  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: block;
  max-width: 80px;
`

export const ItemBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: fit-content;
  position: relative;

  span {
    align-self: center;
    font-size: ${theme.typography.sizes['2xs']};

    strong {
      font-weight: ${theme.typography.weight.lg};
    }
  }
`

export const ColorStock = styled.div`
  width: 80px;
  font-weight: ${theme.typography.weight.xsm};
  font-size: ${theme.typography.sizes.sm};
  color: ${theme.colors.neutral.high};
`

export const SubtotalText = styled(ColorStock)`
  ${({ value }: { value: number }) => value === 0 && `opacity: 0.3;`}
`
